import { HTML5Backend } from 'react-dnd-html5-backend';
import { Backends, MouseTransition, TouchTransition } from 'react-dnd-multi-backend';
import { TouchBackend } from 'react-dnd-touch-backend';

export const CustomHTML5toTouch: Backends = {
  backends: [
    {
      backend: HTML5Backend as any,
      transition: MouseTransition,
    },
    {
      backend: TouchBackend as any, // Note that you can call your backends with options
      options: {
        enableMouseEvents: true,
        delayTouchStart: 200, // allow users to scroll past uploaded photos. allow drag after 200ms of touching
      },
      preview: true,
      transition: TouchTransition,
    },
  ],
};
